const generateOnboardingURL = (user_data: {
  stripe_client_secret: string;
  pending_session_id: string;
  family_name: string;
  given_name: string;
}) => {
  const { given_name, family_name, pending_session_id } = user_data;

  // Encode URI components to ensure special characters are correctly processed
  const queryParams = new URLSearchParams({
    given_name: encodeURIComponent(given_name),
    family_name: encodeURIComponent(family_name),
    pending_session: encodeURIComponent(pending_session_id),
  }).toString();

  const url = `${process.env.NEXT_PUBLIC_WEBAPP_URL}/one_page_checkout/?${queryParams}`;

  return url;
};

export default generateOnboardingURL;
